import React, { ElementRef, useMemo } from 'react';

import { Box } from '@chakra-ui/react';
import { CustomHeaderCell } from 'screens/Team/Rabbit/Goals/AgGridTreeView/components/CustomHeaderCell';
import { useRolesToViewUpdateStatusEditDeleteConfigSelector } from 'screens/admin/Objectives/GoalPreferences/slice/accessControlSlice';

import { AgGridWrapper } from 'uiToolkitV1/AgGridWrapper';

import { viewEditObjectivesTableColDefs } from '../../../constants/colDefs/viewEditTableColDefs';
import { viewEditObjectiveDropdownValues } from '../../../constants/privileges/ViewEditTable';
import { VIEW_EDIT_TABLE_ROLES } from '../../../constants/roles';

interface Props {}

function transformRowDataForAgGrid(rowData: Array<{ [key: string]: any }>) {
  const transformedData = rowData.map((row) => {
    const { name, value, ...rest } = row ?? {};
    let transformedRow = { name, value, ...(rest as any) };
    const subKeys = Object.keys(rest);
    for (const subKey of subKeys) {
      transformedRow = {
        ...transformedRow,
        [subKey]: {
          ...transformedRow[subKey],
          dropdownValues: viewEditObjectiveDropdownValues[subKey],
        },
      };
    }
    return transformedRow;
  });

  return transformedData;
}

const rowDataForAgGrid = (rolesToViewUpdateStatusEditDeleteConfig) =>
  VIEW_EDIT_TABLE_ROLES.map((role) => ({
    name: role.name,
    value: role.value,
    ...(rolesToViewUpdateStatusEditDeleteConfig[role.value] ?? {}),
  }));

const ViewEditObjectivesTable = (props: Props) => {
  const gridRef = React.useRef<ElementRef<typeof AgGridWrapper>>(null);

  const { rolesToViewUpdateStatusEditDeleteConfig } = useRolesToViewUpdateStatusEditDeleteConfigSelector();

  const data = transformRowDataForAgGrid(rowDataForAgGrid(rolesToViewUpdateStatusEditDeleteConfig));

  const defaultColDef = useMemo(
    () => ({
      flex: 0,
      menuTabs: ['filterMenuTab'],
      headerComponent: CustomHeaderCell,
      resizable: false,
    }),
    []
  );

  const gridStatePersistenceKey = null;

  return (
    <Box className="ag-theme-alpine" style={{ width: '100%', height: '600px' }}>
      <AgGridWrapper
        gridStatePersistenceKey={gridStatePersistenceKey}
        useFilterModelPersistence={false}
        useColumnStatePersistence={false}
        ref={gridRef}
        rowData={data}
        columnDefs={viewEditObjectivesTableColDefs}
        animateRows
        rowHeight={70}
        suppressRowTransform
        suppressMenuHide
        getRowId={(data) => data?.data?.value}
        // @ts-ignore
        defaultColDef={defaultColDef}
      />
    </Box>
  );
};

export { ViewEditObjectivesTable };
